import { render, staticRenderFns } from "./RegisterAgentWithPassword.vue?vue&type=template&id=85debe18"
import script from "./RegisterAgentWithPassword.vue?vue&type=script&lang=js"
export * from "./RegisterAgentWithPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports